



































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import { QueryPdPatientList } from "@/api/pdIntegratedManage/pdPatientManage";

import QueryBoard from "@/components/query-board.vue";
import PdOutPatientMain from "../../pdOutPatient/pdOutPatientIndex/main.vue";

@Component({
  components: {
    QueryBoard,
    PdOutPatientMain
  }
})
export default class PdPatientManage extends AbpBase {
  showPatientDetail: boolean = false;
  currentPatient: any = {};
  /**
   * 加载状态
   */
  loading: boolean = false;
  /**
   * 表格数据
   */
  tableData: any[] = [];
  tableTotalSize: number = 0;
  /**
   * 字典表定义
   */
  dicPayType: any[] = [];
  dicSex: any[] = [];

  /**
   * 高级查询条件
   */
  advanceConditions: any[] = [
    {
      name: "string",
      title: "字符串",
      type: "string",
      value: ""
    },
    {
      name: "number",
      title: "数字",
      type: "number",
      value: 0
    },
    {
      name: "numberRange",
      title: "数字范围",
      type: "numberRange",
      minvalue: 0,
      maxvalue: 10
    },
    {
      name: "boolean",
      title: "布尔",
      type: "boolean",
      value: ""
    },
    {
      name: "date",
      title: "日期范围",
      type: "date",
      minvalue: "2019-01-01",
      maxvalue: "2019-10-01"
    },
    {
      name: "select",
      title: "单选",
      type: "select",
      value: "",
      select: [
        {
          id: "1",
          name: "选项1"
        },
        {
          id: "2",
          name: "选项2"
        },
        {
          id: "3",
          name: "选项3"
        }
      ]
    },
    {
      name: "multiple",
      title: "多选",
      type: "multiple",
      value: [],
      select: [
        {
          id: "1",
          name: "选项1"
        },
        {
          id: "2",
          name: "选项2"
        },
        {
          id: "3",
          name: "选项3"
        }
      ]
    }
  ];
  /**
   * 查询条件
   */
  queryCondition: any = {
    QueryString: "",
    SkipCount: 1,
    MaxResultCount: 10,
    SortKey: "id",
    SortOrder: "asc",
    PsnlNo: "",
    Name: "",
    CID: "",
    Card: "",
    Sex: null,
    PayType: "",
    AgeStart: null,
    AgeEnd: null,
    CreationTimeStart: null,
    CreationTimeEnd: null,
    Status: null
  };
  /**
   * 列表
   */
  columns = [
    {
      key: "psnlNo",
      title: "患者编号",
      width: 180,
      sortable: "custom"
    },
    {
      key: "name",
      title: "姓名",
      width: 90,
      sortable: "custom"
    },
    {
      key: "card",
      title: "医保卡号",
      width: 180,
      sortable: "custom"
    },
    {
      key: "cid",
      title: "身份证号",
      width: 200,
      sortable: "custom"
    },
    {
      key: "sexName",
      title: "性别",
      width: 90,
      sortable: "custom"
    },
    {
      key: "age",
      title: "年龄",
      width: 90,
      sortable: "custom"
    },
    {
      key: "payTypeName",
      title: "费用类别",
      width: 120,
      sortable: "custom"
    },
    {
      key: "creationTime",
      title: "登记日期",
      width: 120,
      sortable: "custom",
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.creationTime));
      }
    },
    {
      key: "",
      minWidth: 150,
      title: "操作",
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "default", icon: "md-book", size: "small" },
            style: { marginRight: "20px" },
            on: {
              click: () => {
                this.basicInfo(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "default", icon: "md-person", size: "small" },
            style: { marginRight: "20px" },
            on: {
              click: (event: any) => {
                this.basicInfo(p.row);
                event.stopPropagation();
              }
            }
          })
        ]);
      }
    }
  ];

  /**
   * 代码表
   */
  initDic() {
    GetListByCode({ input: "PD_Dic_Patient_PayType" }).then(res => {
      this.dicPayType = res;
    });
    GetListByCode({ input: "PD_Dic_Sex" }).then(res => {
      this.dicSex = res;
    });
  }

  //基本信息
  basicInfo(row: any) {
    this.currentPatient = row;
    this.showPatientDetail = true;
  }

  //就诊报告
  medicalReport(row: any) {}

  pageChange(val: any) {
    this.queryCondition.SkipCount = val;
    this.getData();
  }

  createPdPatient() {}

  /**
   * 高级查询
   */
  onAdvancedSearch(res: any) {
    this.getData();
  }

  onSortChange(res: any) {
    this.queryCondition.SortKey = res.key;
    this.queryCondition.SortOrder = res.order;
    this.getData();
  }

  async getData() {
    this.loading = true;
    QueryPdPatientList(this.queryCondition)
      .then(res => {
        this.loading = false;
        this.tableData = res.items;
        this.tableTotalSize = res.totalCount;
      })
      .catch(res => {
        this.loading = false;
      });
  }

  created() {
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdIntegratedManage/pdPatientManage/index.vue